/**
 * Hospital Indemnity Valid Fields
 *
 * Set of valid field names for Hospital Indemnity benefits.
 * Used to filter out fields that don't belong to this coverage type.
 */

export const HOSPITAL_INDEMNITY_VALID_FIELDS = new Set([
  "objectType",
  "employerContribution",
  "hospitalAdmission",
  "icuAdmission",
  "hospitalConfinement",
  "icuConfinement",
  "preExistingCondition",
  "portability",
  "wellness",
  "annualOpenEnrollment",
  "extended",
]);
